module.exports = __webpack_public_path__ + "static/media/athboyaviation.c19e3528.png";